<template>
  <el-table-column :label="label" :prop="prop" class-name="airport-code" :sortable="sortable" />
</template>

<script>
export default {
  components: {
  },
  props: {
    label: {
      type: String,
      default: '空港コード'
    },
    prop: {
      type: String,
      default: 'airport_code'
    },
    sortable: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss">
.el-table {
  th,
  td {
    &.airport-code {
      width: 7.5em;
    }
  }
}
</style>
